import {
  LaboratorioLezioneTutoraggioDTO,
  ListLaboratorioLezioneTutoraggioDTO,
  ListStudentePrenotazioneLaboratorioDTO,
  ListSelectDTO,
  SessioneOlaStudenteDTO,
  ListMieiLaboratoriDTO,
  TIPOLOGIA,
} from './../../../model/newModel';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantsCLA } from '../../../shared/constants-cla';
import {
  AddUpdateLaboratorioLezioneTutoraggioCommand,
  SearchLaboratorioLezioneTutoraggioCommand,
  SearchStudentePrenotazioneLaboratorioCommand,
  AppelloCommand,
  EliminaPrenotazioneStudenteCommand,
} from 'src/app/model/command-model';
import {
  GetCommand,
  SelectCommand,
  AbilitaDisabilitaCommand,
} from '../../../model/command-model';

@Injectable({
  providedIn: 'root',
})
export class ALaboratorioLezioneTutoraggioService {
  constructor(private http: HttpClient) {}

  selectAule() {
    const command = new SelectCommand();
    command.tipo = 'LABORATORIO';
    return this.http.post<ListSelectDTO>(ConstantsCLA.AULE_COMBO_URL, command);
  }

  abilitaDisabilita(id: number, isAbilita: boolean) {
    const command = new AbilitaDisabilitaCommand();
    command.id = id;
    command.active = isAbilita;
    return this.http.post<boolean>(
      ConstantsCLA.ABILITA_DISABILITA_LABORATORIO_URL,
      command
    );
  }

  save(
    newLaboratorioLezioneTutoraggio: AddUpdateLaboratorioLezioneTutoraggioCommand
  ) {
    return this.http.post<AddUpdateLaboratorioLezioneTutoraggioCommand>(
      ConstantsCLA.CREA_LABORATORIO_URL,
      newLaboratorioLezioneTutoraggio
    );
  }

  update(
    updateLaboratorioLezioneTutoraggio: AddUpdateLaboratorioLezioneTutoraggioCommand
  ) {
    return this.http.post<AddUpdateLaboratorioLezioneTutoraggioCommand>(
      ConstantsCLA.MODIFICA_LABORATORIO_URL,
      updateLaboratorioLezioneTutoraggio
    );
  }

  getLaboratorioLezioneTutoraggio(idLaboratorioLezioneTutoraggio: number) {
    const command = new GetCommand();
    command.id = idLaboratorioLezioneTutoraggio;
    return this.http.post<LaboratorioLezioneTutoraggioDTO>(
      ConstantsCLA.GET_LABORATORIO_URL,
      command
    );
  }

  getPrenotazioniAppello(
    idLaboratorioLezioneTutoraggio: number,
    idSessioneOla: number
  ) {
    const command = new SearchStudentePrenotazioneLaboratorioCommand();
    command.idLaboratorioLezioneTutoraggio = idLaboratorioLezioneTutoraggio;
    command.idSessioneOla = idSessioneOla;
    return this.http.post<ListStudentePrenotazioneLaboratorioDTO>(
      ConstantsCLA.GET_PRENOTAZIONI_APPELLO_URL,
      command
    );
  }

  appelloLaboratorioStudenti(
    idTutor: number,
    idLaboratorioLezioneTutoraggio: number,
    listaPresenti: SessioneOlaStudenteDTO[]
  ) {
    const command = new AppelloCommand();
    command.listaPresenti = listaPresenti;
    command.idLaboratorio = idLaboratorioLezioneTutoraggio;
    command.idInstructor = idTutor;
    return this.http.post<ListStudentePrenotazioneLaboratorioDTO>(
      ConstantsCLA.APPELLO_LABORATORIO_URL,
      command
    );
  }

  appelloLaboratorioTutor(
    idTutor: number,
    idLaboratorioLezioneTutoraggio: number
  ) {
    const command = new AppelloCommand();
    command.idLaboratorio = idLaboratorioLezioneTutoraggio;
    command.idInstructor = idTutor;

    return this.http.post<Boolean>(
      ConstantsCLA.APPELLO_LABORATORIO_TUTOR_URL,
      command
    );
  }

  // tslint:disable-next-line: max-line-length
  search(
    idTutorSelected: string,
    idSessioneSelected: string,
    abilitatoDisabilitato: string,
    dataSelected: Date,
    mostraTutti: boolean
  ) {
    const laboratorioLezioneTutoraggioSearch = new SearchLaboratorioLezioneTutoraggioCommand();
    laboratorioLezioneTutoraggioSearch.mostraTutti = mostraTutti;
    if(mostraTutti){
      laboratorioLezioneTutoraggioSearch.idSessioneOla = Number(idSessioneSelected);
    }
    laboratorioLezioneTutoraggioSearch.dataSelected = !!dataSelected
      ? dataSelected
      : null;
    laboratorioLezioneTutoraggioSearch.idTutor = Number(idTutorSelected);
    switch (abilitatoDisabilitato) {
      case TIPOLOGIA.ABILITATI:
        laboratorioLezioneTutoraggioSearch.active = true;
        break;
      case TIPOLOGIA.DISABILITATI:
        laboratorioLezioneTutoraggioSearch.active = false;
        break;
    }
    return this.http.post<ListLaboratorioLezioneTutoraggioDTO>(
      ConstantsCLA.SEARCH_LABORATORIO_URL,
      laboratorioLezioneTutoraggioSearch
    );
  }

  getMieiCalendariLaboratori(idTutor: number) {
    const command = new GetCommand();
    command.id = idTutor;
    return this.http.post<ListMieiLaboratoriDTO>(
      ConstantsCLA.I_MIEI_CALENDARI_LABORATORI_URL,
      command
    );
  }

  eliminaPrenotazioneStudenteLaboratorio(
    idPrenotazione: number,
    nomeCompletoStudente: string
  ) {
    const command = new EliminaPrenotazioneStudenteCommand();
    command.id = idPrenotazione;
    command.nomeCompletoStudente = nomeCompletoStudente;

    return this.http.post<Boolean>(
      ConstantsCLA.ELIMINA_PRENOTAZIONE_LABORATORIO_URL,
      command
    );
  }
}
